<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [modalHelpIndex]="modalHelpIndex" [modalClass]="modalClass"
    [isPrimaryButtonHidden]="true">
    <div class="parent-content">
        <div data-automation-id="data-set-import-configuration-ocr-queries-container">
            <div class="header-bar">
                <span>Index Settings</span>
            </div>
            <div class="index-settings-area" style="display: flex;">
                <res-index-settings #indexSettingsControl [isDataSetConfigModal]="true" [handle]="caseDataHandle">
                </res-index-settings>
            </div>
        </div>
        <div class="patterns-content" *ngIf="enablePatternDetection"
            [ngStyle]="{'height' : enablePatternDetection && regexes?.length > 0 ? (((regexes.length + 1) * 30) + 30 + 'px') : '0px'}"
            data-automation-id="data-set-import-configuration-enabled-patterns-container">
            <div class="header-bar">
                <span>Enabled Patterns</span>
                <p class="info-message">Current values are displayed for all patterns. Patterns modified after import
                    are highlighted.</p>
            </div>
            <div class="patterns-settings-area">
                <res-generic-grid #patternsGrid [gridName]="gridName" [automationId]="automationId"
                    [columnDefs]="columnDefs" [pagerVisible]="false" [rowClassRules]="rowClassRules">
                </res-generic-grid>
            </div>
        </div>
        <div class="patterns-content" *ngIf="!enablePatternDetection"
            data-automation-id="data-set-import-configuration-enabled-patterns-container">
            <div class="header-bar">
                <span>Enabled Patterns</span>
            </div>
            <div class="disabled-text" *ngIf="!enablePatternDetection">
                <span> Pattern Detection Disabled </span>
            </div>
        </div>
    </div>
</res-base-modal>